import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import SEO from "../components/SEO";
import { Input } from "../components/ui/input";
import { toast } from "sonner";

// Hidden admin-only email/password login. NOT linked anywhere public.
export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const doLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(form.email, form.password);
      if (user.role !== "admin") {
        toast.error("This area is for store administration only.");
        return;
      }
      toast.success(`Welcome back, ${user.name}`);
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-20" data-testid="admin-login-page">
      <SEO title="Admin Sign In" description="Store administration sign in" />
      <h1 className="text-4xl tracking-tighter font-semibold text-center mb-3">Store Administration</h1>
      <p className="text-sm text-muted-foreground text-center mb-10">Authorized access only.</p>
      <form onSubmit={doLogin} className="flex flex-col gap-4" data-testid="admin-login-form">
        <Input required type="email" placeholder="Admin Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="bg-white" data-testid="login-email" />
        <Input required type="password" placeholder="Password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="bg-white" data-testid="login-password" />
        <button type="submit" disabled={loading} className="bg-[#111] text-[#FAF9F6] py-4 small-caps hover:bg-gold hover:text-[#111] transition-colors duration-300 disabled:opacity-50" data-testid="login-submit">
          {loading ? "Signing in..." : "Sign In"}
        </button>
      </form>
    </div>
  );
}
